import { useState, useEffect } from "react";
import axios from "axios";
import "./resultedit.css";
import IsLoading from "../../../isLoading";
import ResultEditDetails from "./student/ResultEditDetails";
import EditResult from "./student/EditResult";
// import from MUI
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import LockResetIcon from "@mui/icons-material/LockReset";

let dataFetch;

export default function ResultEdit() {
  const [loading, setLoading] = useState(false);
  const [changeview, setChangeView] = useState("");
  const [appNo, setAppNo] = useState("");

  function switchView() {
    switch (changeview) {
      case "edit":
        return <EditResult />;
      case "uploads":
        return <ResultEditDetails />;
      default:
        return <ResultEditDetails />;
    }
  }

  //

  async function getApplicants() {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/reset_student_password`)
      .then((response) => {
        dataFetch = response.data.response;

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    getApplicants();
  }, []);

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className=" result_editing">
          <div className="fx-cl">
            <div className="resulteditBtnSwitch fx-ac fx-jc space1">
              <button
                className={`fx-ac spacem ${
                  changeview === "uploads" ? "active" : ""
                }`}
                onClick={() => setChangeView("uploads")}
              >
                <LockResetIcon />
                <span>Result Edits</span>
              </button>

              <button
                className={`fx-ac spacem ${
                  changeview === "edit" ? "active" : ""
                }`}
                onClick={() => setChangeView("edit")}
              >
                <PrivacyTipOutlinedIcon />
                <span>Edit Result</span>
              </button>
            </div>
          </div>
          {changeview && switchView()}
        </div>
      )}
    </>
  );
}
